module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard",
    style: ('margin-top:' + _vm.fillingNum + 'px')
  }, [_c('vbutton', {
    ref: "dom_rotate",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 0,
      "left": 374,
      "label": _vm.rotation,
      "arrow": "translate(0, 63px)",
      "position": true,
      "active": _vm.keyboard['rotate']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_down",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 180,
      "left": 374,
      "label": _vm.labelDown,
      "arrow": "translate(0,-71px) rotate(180deg)",
      "active": _vm.keyboard['down']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_left",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 284,
      "label": _vm.labelLeft,
      "arrow": "translate(60px, -12px) rotate(270deg)",
      "active": _vm.keyboard['left']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_right",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 464,
      "label": _vm.labelRight,
      "arrow": "translate(-60px, -12px) rotate(90deg)",
      "active": _vm.keyboard['right']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_space",
    attrs: {
      "color": "blue",
      "size": "s0",
      "top": 100,
      "left": 52,
      "label": _vm.labelDropSpace,
      "active": _vm.keyboard['drop']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_r",
    attrs: {
      "color": "red",
      "size": "s2",
      "top": 0,
      "left": 196,
      "label": _vm.labelResetR,
      "active": _vm.keyboard['reset']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_s",
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 106,
      "label": _vm.labelSoundS,
      "active": _vm.keyboard['music']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_p",
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 16,
      "label": _vm.labelPauseP,
      "active": _vm.keyboard['pause']
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0118c1ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyboard/index.vue
// module id = 129
// module chunks = 1